import { MeGetResponse } from '../model/authModel';
import { API_REQUEST_STATE } from '../../enums/apiRequestState';

export enum AUTH_TYPES {
  SET_IS_AUTHENTICATED = 'SET_IS_AUTHENTICATED',
  SET_API_ME_REQUEST_STATE = 'SET_API_ME_REQUEST_STATE',
  API_ERROR = 'AUTH_API_ERROR',
  LOGIN = 'AUTH_LOGIN',
  LOGOUT = 'AUTH_LOGOUT',
  GET_ME = 'GET_ME',
  GET_ME_ERROR = 'GET_ME_ERROR',
  GET_ME_SUCCESS = 'GET_ME_SUCCESS',
}

export interface SetIsAuthenticatedAction {
  type: AUTH_TYPES.SET_IS_AUTHENTICATED;
  payload: {
    isAuthenticated: boolean;
  };
}

export interface SetApiMeRequestStateAction {
  type: AUTH_TYPES.SET_API_ME_REQUEST_STATE;
  payload: {
    apiMeRequestState: API_REQUEST_STATE;
  };
}

export interface ApiError {
  response: {
    status: number;
  };
}

export interface ApiErrorAction {
  type: AUTH_TYPES.API_ERROR;
  payload: {
    errorCode: number;
  };
}

export interface LoginAction {
  type: AUTH_TYPES.LOGIN;
  payload: null;
}

export interface LogoutAction {
  type: AUTH_TYPES.LOGOUT;
  payload: null;
}

export interface GetMeAction {
  type: AUTH_TYPES.GET_ME;
  payload: null;
}

export interface GetMeSuccessAction {
  type: AUTH_TYPES.GET_ME_SUCCESS;
  payload: {
    me: MeGetResponse;
  };
}

export interface GetMeErrorAction {
  type: AUTH_TYPES.GET_ME_ERROR;
  payload: null;
}

export type AuthActionTypes =
  | ApiErrorAction
  | SetApiMeRequestStateAction
  | LoginAction
  | LogoutAction
  | GetMeAction
  | GetMeSuccessAction
  | SetIsAuthenticatedAction
  | GetMeErrorAction;

export interface AuthState {
  apiMeRequestState: API_REQUEST_STATE;
  errorCode: null | number | undefined;
  isAuthenticated: boolean;
  me: MeGetResponse;
}
